module.exports = __webpack_public_path__ + "src/assets/svg/spaceman.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/spaceman.svg
// module id = 103
// module chunks = 0